import Rest from '@services/Rest';

/**
 * @typedef {AdjustSaleCommand}
 */
export default class AdjustSaleCommand extends Rest {
  /**
   * @type {String}
   */
  static resource = '/admin/adjust-sale-command';
}
